module.exports = __webpack_public_path__ + "img/5ac_32.2d1ed69e.gif";